import {
    Toast
} from 'vant';

/**
 * 验证token是否为空
 * @param {String} token  token值
 * @param {Boolean} showToast 是否显示提示
 * @returns {Boolean} 返回验证状态
 */
export default function(token, showToast) {
    if (token || window.sessionStorage.token) {
        token && window.sessionStorage.setItem('token', token);
        return true;
    }
    showToast !== false && Toast({
        message: '登录状态无效\n请重新登录',
        icon: 'close'
    });
    return false;
}